import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-primary-950/95 backdrop-blur border-primary-800/60"
          : "bg-primary-950/70 backdrop-blur-sm border-primary-900/40"
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 md:h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer group">
          <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-primary-950 text-lg shrink-0">
            <i className="ri-movie-2-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-background-50 text-base md:text-lg tracking-wide whitespace-nowrap">
              {siteInfo.brand}
            </span>
            <span className="font-label text-accent-400 text-[10px] md:text-[11px] tracking-[0.2em] uppercase">
              Film Portal
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.path === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "text-accent-400 font-medium"
                    : "text-background-100/80 hover:text-background-50 hover:bg-primary-900/60"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-md text-sm text-background-100/80 hover:text-background-50 hover:bg-primary-900/60 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-base"></i>
            <span className="whitespace-nowrap">搜索</span>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-background-50 hover:bg-primary-900/60 transition-colors cursor-pointer"
            aria-label="打开导航菜单"
          >
            <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-primary-800/60 bg-primary-950/98 backdrop-blur px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm transition-colors cursor-pointer ${
                    isActive
                      ? "bg-primary-900 text-accent-400 font-medium"
                      : "text-background-100/80 hover:bg-primary-900/60"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}